﻿import Swal from "sweetalert2";

export const cancelDialog = function (
  title: string,
  text: string,
  confirmText: string,
  actionConfirmed: () => void,
  actionCancelled?: () => void,
  cancelText?: string
) {
  Swal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: confirmText,
    showCloseButton: true,
    cancelButtonText: cancelText ?? "Close",
    buttonsStyling: false,
    customClass: {
      cancelButton: 'btn-tertiary',
      confirmButton: 'btn-primary'
    }
  }).then(result => {
    if (result.isConfirmed) {
      actionConfirmed();
    } else if (actionCancelled) {
      actionCancelled();
    }
  });
};
